import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreLayoutFeatureCustomLayoutModule } from '@nx-ratenow/core/layout/feature-custom-layout';
import { StoreModule } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import * as fromUserStore from '@nx-ratenow/core/data-access-user';
import {
  HttpConfigInterceptor,
  HttpErrorInterceptor,
  RetryInterceptor,
  LanguageInterceptor,
  JwtInterceptor
} from '@nx-ratenow/core/interceptors';
import { AppAdminUserRoutingModule } from './app-routing.module';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { CoreFeatureNotificationModule } from '@nx-ratenow/core/feature-notifications';
import { APP_TYPE } from '@nx-ratenow/core/config';
import { AplicationTypeName } from '@nx-ratenow/shared/enums';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MtxNativeDatetimeModule } from '@ng-matero/extensions/core';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [AppComponent, MainLayoutComponent],
  imports: [
    AppAdminUserRoutingModule,
    MatDatepickerModule,
    MatNativeDateModule,

    CoreFeatureNotificationModule,
    MtxNativeDatetimeModule,
    BrowserModule,

    HttpClientModule,
    BrowserAnimationsModule,

    MatDialogModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatSelectModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    
    CoreLayoutFeatureCustomLayoutModule,

    // STORE

    StoreModule.forRoot(
      {
        router: routerReducer
      },
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: false,
          strictActionSerializability: false
        }
      }
    ),
    StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot([]),

    // AUTH - USER

    StoreModule.forFeature(
      fromUserStore.AUTH_FEATURE_KEY,
      fromUserStore.reducer,
      {
        metaReducers: [fromUserStore.localStorageSyncReducer],
        initialState: fromUserStore.initialState
      }
    )
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'es'
    },
    {
      provide: APP_TYPE,
      useValue: AplicationTypeName.adminUsers
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
